export type PageSize = 'A4' | 'A3';
export type Orientation = 'landscape' | 'portrait';
export type MapScale = '1:10000' | '1:25000';
export type GridSize = '100km' | '1km' | '100m';

export interface ExportSettings {
    pageSize: PageSize;
    orientation: Orientation;
    scale: MapScale;
}

// Paper dimensions in mm
export const PAGE_DIMENSIONS: Record<PageSize, { width: number; height: number }> = {
    'A4': { width: 210, height: 297 },
    'A3': { width: 297, height: 420 },
};

// Scale factors (ground meters per mm on paper)
export const SCALE_FACTORS: Record<MapScale, number> = {
    '1:10000': 10000,
    '1:25000': 25000,
};

// Get effective paper dimensions based on orientation
export function getEffectiveDimensions(pageSize: PageSize, orientation: Orientation): { width: number; height: number } {
    const dims = PAGE_DIMENSIONS[pageSize];
    return orientation === 'landscape'
        ? { width: dims.height, height: dims.width }
        : { width: dims.width, height: dims.height };
}
